/**
 * Names the next sprint on a board.
 *
 * Counting the sprints and adding one seems right until you look at a real
 * board: sprints get deleted, and boards get created mid-project already on
 * "Sprint 12". Counting there produces "Sprint 2" — a name that reads as a step
 * backwards and collides with a sprint that may still exist.
 *
 * So continue the sequence instead of measuring it: take the highest number
 * anyone has already used and go one past it. A board whose sprints are named
 * something other than "Sprint N" has no sequence to continue, and falls back
 * to the count.
 */
export function nextSprintName(existingNames: string[]): string {
  let highest = 0;

  for (const name of existingNames) {
    // Only a trailing integer counts. "Sprint 12" continues the sequence;
    // "Sprint 12 — hardening" is a name someone chose, not a position in it.
    const match = /^\s*sprint\s+(\d+)\s*$/i.exec(name);
    if (match) highest = Math.max(highest, Number(match[1]));
  }

  return `Sprint ${Math.max(highest, existingNames.length) + 1}`;
}
